import React from "react";
import { Messages } from "primereact/messages";

const BaseMessages = React.forwardRef((props,ref) => {
  return (<Messages {...props} ref={ref} className={`${props.custom ? props.custom : ""} ${props.extra ? props.extra : ""}`}/>);
})

export default BaseMessages;